import styled, { keyframes } from 'styled-components';

var loaderFx = keyframes(["0%{background-position:-300px 0;}100%{background-position:700px 0;}"]);
var LoadBlock = styled.div.withConfig({
  displayName: "style__LoadBlock",
  componentId: "sc-1cxz26b-0"
})(["height:100%;position:relative;width:100%;"]);
var Loader = styled.div.withConfig({
  displayName: "style__Loader",
  componentId: "sc-1cxz26b-1"
})(["animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;background:var(--color-grey-25) no-repeat;background-image:linear-gradient(to left,var(--color-grey-25) 0%,var(--color-grey-100) 20%,var(--color-grey-25) 40%,var(--color-grey-25) 100%);background-size:200px 100%;height:100%;position:absolute;width:100%;"], loaderFx);

export { LoadBlock, Loader };
//# sourceMappingURL=style.js.map
